import { api } from '@/lib/api'
import type {
  ForkStrategyRequest,
  Rule,
  StrategyDetail,
  StrategyHistoryResponse,
  UpdateRulePayload,
} from '@/types/strategy'

export async function getCurrentStrategy(): Promise<StrategyDetail> {
  const { data } = await api.get<StrategyDetail>('/strategy/current')
  return data
}

export async function getStrategyDetail(id: number): Promise<StrategyDetail> {
  const { data } = await api.get<StrategyDetail>(`/strategy/${id}`)
  return data
}

export async function listStrategyHistory(): Promise<StrategyHistoryResponse> {
  const { data } = await api.get<StrategyHistoryResponse>('/strategy/history')
  return data
}

export async function seedStrategy(): Promise<StrategyDetail> {
  const { data } = await api.post<StrategyDetail>('/strategy/seed')
  return data
}

export async function confirmStrategy(id: number): Promise<StrategyDetail> {
  const { data } = await api.post<StrategyDetail>(`/strategy/${id}/confirm`)
  return data
}

export async function forkStrategy(
  id: number,
  body: ForkStrategyRequest = {},
): Promise<StrategyDetail> {
  const { data } = await api.post<StrategyDetail>(`/strategy/${id}/fork`, body)
  return data
}

export async function updateRule(
  strategyId: number,
  ruleId: number,
  payload: UpdateRulePayload,
): Promise<Rule> {
  const { data } = await api.patch<Rule>(`/strategy/${strategyId}/rules/${ruleId}`, payload)
  return data
}
